import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Post, CartListURL,RemoveCart, AddToCartURL, ApplyCouponUrl, CouponListUrl, image_url, CountryUrl, StateUrl, CityUrl, AddAddressUrl, ListAddressUrl, RemoveAddrUrl, savebookingUrl } from "../utils/api";
import Footer from "./footer";
import Header from "./Header";
import {wrapComponent} from 'react-snackbar-alert';
import Modal from 'react-bootstrap/Modal';
import Button from "../component/Button";
import {Loader} from './../component/Loader2';
import Payment from './../component/payment';
import { useSelector } from "react-redux";

function Checkout({createSnackbar}) {
    const navigate = useNavigate();

    const [cartItem,setCartItem] = useState([]);
    const [countryList,setcountryList] = useState([]);
    const [addressList,setaddressList] = useState([]);
    const [stateList,setstateList] = useState([]);
    const [cityList,setcityList] = useState([]);
    const [CouponList,setCouponList] = useState([]);
    const [discount,setdiscount] = useState(0);
    const [deliver,setdeliver] = useState(60);
    const [isLoading,setisLoading] = useState(false);
    const [selectedAddress,setselectedAddress] = useState(false);
    const [tax,settax] = useState(180);
    const [applyed,setapplyed] = useState('');

    const [show, setShow] = useState(false);
    const [showAddressMmodal, setshowAddressMmodal] = useState(false);
    const [state,setState] = useState({
        first_name:'',
        last_name:'',
        house_no:'',
        apartment:'',
        pincode:'',
        country:'',
        state:'',
        city:'',
        type:'home',
        address_id:''
    })

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };


    useEffect(()=>{
        fetchCartList()
        couponList();
        fetchCountyList();
        ListAddress();
    },[])
    
  const showSnack = (msg='',type='error') =>{
    createSnackbar({
      message: msg,
      theme: type,
    });
  }

  const fetchCartList = () =>{
    global.Loader(true)
    let config = {
        url:CartListURL,
    }
    Post(config).then((res)=>{
        global.Loader(false)
        if(res.status == true) {
            setCartItem(res?.data)
        }
    }).catch((err)=>{
      global.Loader(false)
      console.log(err?.response?.data);
    })
  }

  const fetchCountyList = () =>{
    let config = {
        url:CountryUrl,
    }
    Post(config).then((res)=>{
        if(res.status == true) {
            setcountryList(res?.data)
        }
    }).catch((err)=>{
      console.log(err?.response);
    })
  }

  const fetchStateList = (id) =>{
    setisLoading(true)
    let config = {
        body:{country_id:id},
        url:StateUrl,
    }
    Post(config).then((res)=>{
        setisLoading(false)
        if(res.status == true) {
            setstateList(res?.data)
        }
    }).catch((err)=>{
      setisLoading(false)
      console.log(err?.response?.data);
    })
  }

  const fetchCityList = (id) =>{
    setisLoading(true)
    let config = {
        body:{state_id:id},
        url:CityUrl,
    }
    Post(config).then((res)=>{
        setisLoading(false)
        if(res.status == true) {
            setcityList(res?.data)
        }
    }).catch((err)=>{
      setisLoading(false)
      console.log(err?.response?.data);
    })
  }
  const {cartItems} = useSelector((state)=>state);

    const removeItem = ({id,product_id,variant_id}) =>{
        global.Loader(true)
        let config = {
            body:{
                cart_id:id,
                variant_id:variant_id,
                product_id:product_id
            },
            url:RemoveCart,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                fetchCartList();

                let index = cartItems?.findIndex((v)=>v.product_id == id);
                if(index == -1) {
                    cartItems.splice(index,1);
                    global.dispatch({
                        type:'CARTITEMS',
                        payload: cartItems
                    })
                }
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const couponList = () =>{
        global.Loader(true)
        let config = {
            url:CouponListUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                setCouponList(res.data);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const ListAddress = () =>{
        global.Loader(true)
        let config = {
            url:ListAddressUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                setaddressList(res.data);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const deleteAddress = (id) =>{
        global.Loader(true)
        let config = {
            body:{address_id:id},
            url:RemoveAddrUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                ListAddress();
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const applyCoupon = (code) =>{
        if(code) {
            global.Loader(true)
            let config = {
                body:{
                    coupon_code:code,
                    amount:calculatePrice(),
                },
                url:ApplyCouponUrl,
            }
            Post(config).then((res)=>{
                global.Loader(false)
                if(res.status == true) {
                    setapplyed(code);
                    setdiscount(res?.minus_amount);
                    showSnack(res.message,'success');
                } else {
                    showSnack(res.message);
                }
            }).catch((err)=>{
                global.Loader(false)
                console.log(err?.response?.data);
            })
        } else {
            showSnack('Enter Coupon Code');
        }
    }


    const checkoutBooking = ({razorpay_payment_id}) =>{
        global.Loader(true)
        let body = {
            address_id:selectedAddress,
            payment_option:'razorpay',
            transaction_id:razorpay_payment_id,
        }
        if(applyed) {
            body.coupon_code = applyed;
        }

        let config = {
            body:body,
            url:savebookingUrl,
        }

        Post(config).then((res)=>{
            global.Loader(false);
            if(res.status == true) {
                fetchCartList();
                showSnack(res.msg,'success');
                navigate('/dashboard');
            } else {
                showSnack(res.message);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const submitAddAddress = () =>{
        setisLoading(true)
        let body = {
            first_name:state.first_name,
            last_name:state.last_name,
            house_no:state.house_no,
            apartment:state.apartment,
            pincode:state.pincode,
            country:state.country,
            state:state.state,
            city:state.city,
            address_type:state.type,
        }

        if(state?.address_id) {
            body.address_id = state.address_id
        };
        
        let config = {
            body:body,
            url:AddAddressUrl,
        }
        Post(config).then((res)=>{
            setisLoading(false)
            setshowAddressMmodal(false)
            if(res.status == true) {
                ListAddress();
                showSnack(res.message,'success');
            }
        }).catch((err)=>{
            setshowAddressMmodal(false)
            setisLoading(false)
            console.log(err?.response?.data);
        })
    }

    const calculatePrice = () =>{
        let list = [...cartItem];
        let total = 0;
        for(let item of list) {
            total += (item.price * item.quantity)
        }
        return total;
    }

    const truncate = (value,i=25) =>{
        if(value) {
            return `${value.substr(0,i)}...`;
        } else {
            return '';
        }
    }
    

    if(cartItem?.length == 0) {
        return (
            <div>
                <Header />
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection:'column'
                }}>
                    <img src="/images/emptycart.png" />
                    <span style={{
                        fontSize: '35px',
                        marginTop: '-8%',
                    }}>Your cart is empty</span>
                    <Link to={'/shoppage'} style={{
                        fontSize: '20px',
                        color:'#000',
                        textDecoration:'underline'
                    }}>Continue Shopping</Link>
                </div>
            </div>
        )
    }

    return (
        <div className="best">
            <Header />
        <div className="row checkmain">
            {(addressList?.length != 0) ?
            <div className="col-md-7" style={{marginLeft:'20px',
                height: '791px',
                overflowY: 'scroll',
                display:'flex',
                alignItems:'center',
                flexDirection:'column'
                }}>
                
                {addressList?.map((v,i)=>(
                    <div onClick={()=>{
                        setselectedAddress(v?.id)
                    }} style={{
                        marginBottom:'20px',
                        width: '50%',
                        backgroundColor: 'white',
                        padding: '20px',
                        marginTop:'10px',
                        borderRadius: '10px',
                        '-webkit-box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                        '-moz-box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                        'box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                        border:(v?.id==selectedAddress)?'2px solid #219653':'0px',
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'space-between'
                    }}>
                        <div>
                            <div>Name : {v.first_name} {v.last_name}</div>
                            <div>Address : {v.house_no} {v.apartment} {v.pincode} {v.city_name}, {v.state_name}, {v.country_name}</div>
                        </div>
                        <div onClick={()=>{
                            setState({
                                first_name:v?.first_name,
                                last_name:v?.last_name,
                                house_no:v?.house_no,
                                apartment:v?.apartment,
                                pincode:v?.pincode,
                                country:v?.country_id,
                                state:v?.state_id,
                                city:v?.city_id,
                                type:v?.address_type,
                                address_id:v?.id
                            });
                            fetchCityList(v?.state_id);
                            fetchStateList(v?.country_id);
                            setshowAddressMmodal(true);
                        }}>
                            <i className="fa fa-edit" aria-hidden="true"></i>
                        </div>
                        <div onClick={()=>{
                            deleteAddress(v.id)
                        }}>
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                ))}
            </div>
            :
            <div className="col-md-7" style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}>
                <img src="/images/noaddr.png"  />
                <span style={{marginTop:'-50px',fontSize:'20px',marginBottom:'30px'}}>No Address Found</span>
                <div onClick={()=>{
                    setshowAddressMmodal(true);
                }} style={{
                    width: '20%',
                    backgroundColor: '#219653',
                    height: '6%',
                    borderRadius: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color:'#FFFFFF'
                }}>
                    <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;Add Address
                </div>
            </div>
            }
            <div className="checkoutbox col-md-4">
                <div className="checkouthead">
                    <span className="ipsum"><i className="fa-solid fa-left-long"></i></span>
                    <h2>Items in cart</h2>
                    <p>Your Cart ₹{calculatePrice()}</p>
                    <div className="crossicon">
                        {/* <!-- <i className="fa-solid fa-xmark"></i> --> */}
                    </div>
                </div>
                <div className="checkmainarea">
                    {cartItem?.map((v,i)=>(
                        <div className="itembox">
                            <h3>
                                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                    <div><i className="fa-solid fa-circle-info"></i> {truncate(v?.title,30)}
                                    </div>
                                    
                                     <i onClick={()=>{
                                removeItem(v)
                            }} style={{color:'red',marginRight:'20px'}} className="fa-solid fa-trash"></i>
                            </div>
                            </h3>
                            <div className="productmix">
                                <div className="productimg">
                                    <img src={`${image_url}${v.image}`} alt=""/>
                                </div>
                                <div className="producttext">
                                    <h2>{truncate(v.title,55)}</h2>
                                    {/* <p>30 Capsules</p> */}
                                </div>
                            </div>
                            <div className="productprice">
                                <ul>
                                    <li>
                                        Quantity: 
                                        <select onChange={({target})=>{
                                            let items = [...cartItem];
                                            
                                            for(let v2 of items) {
                                                if(v2.id == v.id) {
                                                    v2.quantity = target.value;
                                                    break;
                                                }
                                            }

                                            setCartItem(items);
                                        }} value={v?.quantity}  style={{
                                            'backgroundColor': 'transparent',
                                            'border': '0px',
                                        }}>
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                            <option>6</option>
                                            <option>7</option>
                                            <option>8</option>
                                            <option>9</option>
                                            <option>10</option>
                                        </select>
                                        {/* <i className="fa fa-angle-down" aria-hidden="true"></i>  */}
                                    </li>
                                    <li>
                                        <b>
                                            <i className="fa fa-inr" aria-hidden="true"></i> {v?.price}
                                        </b>
                                        {/* <s>600</s> */}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    ))}
                    
                    <div className="before_you">
                        <h1>Before you checkout</h1>
                    </div>
                    <div className="owl-carousel latter_mix owl-theme">
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                        <div className="item">
                            <img src="/images/latte-mix.png" alt=""/>
                            <h3 className="text-center">Latte Mix</h3>
                            <div className="regular">
                                <p>Orange | 200g</p>
                            </div>
                            <div className="icon-star icon_solid">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <p>16</p>
                            </div>
                            <p>Contains healing enzymes, which repair dead skin cells and make skin glow.</p>
                            <h2 className="text-center">₹599 <span><s>800</s></span></h2>
                        </div>
                    </div>
                    <div className="offerbtn" onClick={()=>{
                        setShow(true)
                    }}>
                        <ul>
                            <li>
                                <img src="/images/Vector1.png" alt=""/>
                            </li>
                            <li>
                                <h2>Best Offers</h2>
                                <p>Apply now to save extra</p>
                            </li>
                            <li><a href="#"><i className="fa fa-chevron-right" aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                    <div style={{display:'flex',justifyContent:'center'}}>
                    {addressList?.map((v,i)=>(
                        (v?.id==selectedAddress)&&
                        <div onClick={()=>{
                        }} style={{
                            marginBottom:'20px',
                            width: '80%',
                            backgroundColor: 'white',
                            padding: '20px',
                            marginTop:'30px',
                            borderRadius: '10px',
                            '-webkit-box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                            '-moz-box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                            'box-shadow': 'rgba(0, 0, 0, 0.75) 1px 1px 5px 0px',
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center',
                            alignSelf:'center'
                        }}>
                            <div>
                                <div>Name : {v.first_name} {v.last_name}</div>
                                <div>Address : {v.house_no} {v.apartment} {v.pincode} {v.city_name}, {v.state_name}, {v.country_name}</div>
                            </div>
                        </div>
                    ))}
                    </div>
                    <div className="billarea">
                        <h2>Bill Details</h2>
                        <div className="billdata">
                            <ul>
                                <li>Item Total</li>
                                <li><i className="fa fa-inr" aria-hidden="true"></i>{calculatePrice()}</li>
                            </ul>
                            <ul>
                                <li>Delivery Fee</li>
                                <li><i className="fa fa-inr" aria-hidden="true"></i>{deliver}</li>
                            </ul>
                            <ul>
                                <li>Taxes and Charges</li>
                                <li><i className="fa fa-inr" aria-hidden="true"></i>{tax}</li>
                            </ul>
                            {(applyed != '')&&
                                <ul>
                                    <li>Discount ({applyed}) <span style={{
                                        color: 'white',
                                        backgroundColor: 'red',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        borderRadius: '10px',
                                    }} onClick={()=>{
                                        setdiscount('');
                                        setapplyed('');
                                    }}>Remove</span></li>
                                    <li>- <i className="fa fa-inr" aria-hidden="true"></i>{discount}</li>
                                </ul>
                            }
                            <ul style={{marginBottom:'10px'}}>
                                <li>To Pay</li>
                                <li><i className="fa fa-inr" aria-hidden="true"></i>{parseFloat(calculatePrice()) + deliver + tax - discount}</li>
                            </ul>
                            {(discount!='')&&<h3>You save <i className="fa fa-inr" aria-hidden="true"></i> {discount} with this order!</h3>}
                            {(selectedAddress!='')?
                            <Payment onSubmit={checkoutBooking} amount={parseFloat(calculatePrice()) + deliver + tax - discount}  title={'Proceed to checkout'} />
                            :
                            <Button backgroundColor={'#219653'} onClick={()=>{
                                showSnack('Please Select Address');
                            }} title={'Proceed to checkout'} />
                             }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal show={show} onHide={()=>{
            setShow(false)
            }}>
            <Modal.Header closeButton>
            <Modal.Title>Coupons</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {CouponList?.map((v,i)=>(
                    <div onClick={()=>{
                        setShow(false)
                        applyCoupon(v.coupon_code);
                    }} style={{borderBottom:'1px solid lightgray',marginBottom:'10px',paddingBottom:'10px'}}>
                        Coupon code :- {v.coupon_code}
                    </div>
                ))}
                
            </Modal.Body>
        </Modal>

        <Modal show={showAddressMmodal} onHide={()=>{
            setshowAddressMmodal(false)
            }}>
            <Loader isLoading={isLoading} />
            <Modal.Header closeButton>
            <Modal.Title>Add Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input value={state.first_name} type={'text'} onChange={({target})=>{
                    stateHandler('first_name',target.value)
                }} placeholder="First Name"  style={{...styles.input}} />
                <input value={state.last_name} type={'text'} onChange={({target})=>{
                    stateHandler('last_name',target.value)
                }} placeholder="Last Name"  style={{...styles.input}} />
                <input value={state.house_no} type={'number'} onChange={({target})=>{
                    stateHandler('house_no',target.value)
                }} placeholder="House No"  style={{...styles.input}} />
                <input value={state.apartment} type={'text'} onChange={({target})=>{
                    stateHandler('apartment',target.value)
                }} placeholder="Apartment"  style={{...styles.input}} />
                <input value={state.pincode} type={'number'} onChange={({target})=>{
                    stateHandler('pincode',target.value)
                }} placeholder="Pincode"  style={{...styles.input}} />
                <select value={state.country} onChange={({target})=>{
                    stateHandler('country',target.value)
                    fetchStateList(target.value)
                }} style={styles.input}>
                    <option value={''}>Select Country</option>
                    {countryList?.map((v)=><option value={v.id}>{v.name}</option>)}
                </select>
                <select value={state.state} onChange={({target})=>{
                    stateHandler('state',target.value)
                    fetchCityList(target.value)
                }} style={styles.input}>
                    <option value={''}>Select State</option>
                    {stateList?.map((v)=><option value={v.id}>{v.name}</option>)}
                </select>
                <select value={state.city} onChange={({target})=>{
                    stateHandler('city',target.value);
                }}  style={styles.input}>
                    <option value={''}>Select City</option>
                    {cityList?.map((v)=><option value={v.id}>{v.city}</option>)}
                </select>
                
                <div className="row" style={{marginLeft:'20px'}}>
                    <div className="col-md-3">
                        <input value={state.type} onChange={({target})=>{
                            stateHandler('type',target.value)
                        }} type="radio" checked id="home" name="type" value="home" />
                        <label style={{marginLeft:'10px'}} for="home"> Home</label><br/>
                    </div>
                    <div className="col-md-3">
                        <input value={state.type} onChange={({target})=>{
                            stateHandler('type',target.value)
                        }}  type="radio" id="work" name="type" value="work" />
                        <label style={{marginLeft:'10px'}} for="work"> Work</label><br/>
                    </div>
                </div>
                <div style={{display:'flex',marginTop:'40px',marginBottom:'20px',alignItems:'center',justifyContent:'center'}}>
                    <Button onClick={()=>{
                        submitAddAddress()
                    }} disable={(state.first_name=='' || state.last_name=='' || state.house_no=='' || state.apartment=='' || state.pincode=='' || state.country=='' || state.state=='' || state.city=='')} backgroundColor={'#219653'} title={'Submit'} />
                </div>
            </Modal.Body>
        </Modal>
        </div>
    );
};
  
export default wrapComponent(Checkout);


const styles = {
    input:{
      fontFamily:'Montserrat',
      borderWidth:0,
      textAlign:'left',
      backgroundColor:'#CCDDFF',
      width:410,
      height:50,
      borderRadius:10,
      marginBottom:15,
      paddingLeft:20,
      marginLeft:30
    }
  }